import React from 'react'
import GenJumbo from '../../Components/GeneralJumbotron/GenJumbo';

const Privacy = () => {

    const privacyStyles = {
        privacyRow: {
            marginBottom: "1%"
        },
        questionBtn: {
            backgroundColor: "#F2F2F2",
        }
    }

  return (
    <div>
        <GenJumbo />

        <div className="row" style={privacyStyles.privacyRow}>
            <div className="col-md-1"></div>
            <div className="col-md-10">
                <h3>Information We Collect</h3>
                <h6>When you register on our website, we may collect the following personal and business-related information:</h6>
                <ul>
                    <li>Email address</li>
                    <li>Password (encrypted and stored securely)</li>
                    <li>First and last name</li>
                    <li>Organization</li>
                    <li>Industry</li>
                    <li>Role</li>
                    <li>City, State, and Country</li>
                    <li>Phone number</li>
                    <li>Marketing preferences (e.g., opt-in to semi-annual mailings)</li>
                </ul>
            </div>
            <div className="col-md-1"></div>
        </div>

        <div className="row" style={privacyStyles.privacyRow}>
            <div className="col-md-1"></div>
            <div className="col-md-10">
                <h3>How We Use Your Information</h3>
                <h6>We use this information to:</h6>
                <ul>
                    <li>Create and manage your account</li>
                    <li>Contact you regarding product inquiries or support</li>
                    <li>Improve our offerings and understand user demographics</li>
                    <li>Send occasional product or company updates, unless you have opted out</li>
                    <li>Track engagement and improve our marketing effectiveness</li>
                </ul>
            </div>
            <div className="col-md-1"></div>
        </div>

        <div className="row" style={privacyStyles.privacyRow}>
            <div className="col-md-1"></div>
            <div className="col-md-10">
                <h3>Tracking Technologies</h3>
                <h6>We use the following tools on our site. These tools may use cookies and collect IP address, browser type, referral source, and time spent on pages. You can disable cookies or opt out through the resources provided:</h6>
                <ul>
                    <li>Google Analytics to understand website usage
                        <br/> <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">Google Opt-Out</a>
                    </li>
                    <li>Reddit Pixel to measure advertising performance
                        <br/> <a href="https://www.reddit.com/policies/privacy-policy" target="_blank">Reddit Privacy Settings</a>
                    </li>
                    <li>HubSpot to manage form submissions and communications</li>
                </ul>
            </div>
            <div className="col-md-1"></div>
        </div>

        <div className="row" style={privacyStyles.privacyRow}>
            <div className="col-md-1"></div>
            <div className="col-md-10">
                <h3>Data Sharing</h3>
                <h6>We do NOT sell or rent your personal data. Your information is never shared with third parties for advertising or unrelated purposes.</h6>
            </div>
            <div className="col-md-1"></div>
        </div>

        <div className="row" style={privacyStyles.privacyRow}>
            <div className="col-md-1"></div>
            <div className="col-md-10">
                <h3>Your Rights</h3>
                <h6>You may make any of the below requests. To make any of these requests, email us at <a href="mailto:info@highlandtechnology.com" target="_blank">info@highlandtechnology.com</a>.</h6>
                <ul>
                    <li>Request a copy of your data</li>
                    <li>Correct or update your information</li>
                    <li>Opt out of email communications at any time</li>
                    <li>Request deletion of your account or personal data (unless we are required by law to retain it)</li>
                    <li>Track engagement and improve our marketing effectiveness</li>
                </ul>
            </div>
            <div className="col-md-1"></div>
        </div>

        <div className="row" style={privacyStyles.privacyRow}>
            <div className="col-md-1"></div>
            <div className="col-md-10">
                <h3>Data Security</h3>
                <h6>We protect your information through HTTPS encryption, secure storage, and restricted access.</h6>
            </div>
            <div className="col-md-1"></div>
        </div>

        <div className="row" style={privacyStyles.privacyRow}>
            <div className="col-md-1"></div>
            <div className="col-md-10">
                <h3>Policy Updates</h3>
                <h6>We may periodically update this Privacy Policy. The latest version will always be available on this page.</h6>
            </div>
            <div className="col-md-1"></div>
        </div>

        <div className="row" style={privacyStyles.privacyRow}>
            <div className="col-md-1"></div>
            <div className="col-md-10">
                <h3>Contact Us</h3>
                <h6>If you have any questions or concerns about this policy, reach out to:</h6>
                <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                        Highland Technology, Inc. <br/>
                        650 Potrero Avenue <br/>
                        San Francisco, CA 94110 <br/>
                        United States <br/>
                        <a href="mailto:info@highlandtechnology.com" target="_blank">info@highlandtechnology.com</a><br/>
                        415-551-1700
                    </li>
                </ul>
            </div>
            <div className="col-md-1"></div>
        </div>

    </div>








  )
}

export default Privacy